import type debtReportId from "./id";

const debtReportEn: typeof debtReportId = {
	debt_report: {
		title: "Customer Debt Report",
		table: {
			title: "Customer Debt Report Data",
			columns: {
				cust_name: "Customer Name",
				id_card: "ID Card",
				debt_value: "Debt Value",
				status: "Status",
			},
		},
		status: {
			paid: "Paid",
			unpaid: "Unpaid",
		},
		empty_state: {
			title: "There is no debt report data from customers yet",
			description: "There is no debt report data from customers yet",
		},
	},
};

export default debtReportEn;
